import React from "react";
import { connect } from "react-redux";
import { Field } from "redux-form";
import { lower } from "change-case";
import { getStampDutyOptions } from "ducks/options";
import FieldInput, { InputType as type } from "components/SemanticForm";
import { RICont } from "./styled";
import { RowFields } from "../../styled";
import { StdCard } from "components";

const RequestInformation = (props) => {
  const { isDetail = false, isNewVersion, stampDutyOptions } = props;

  React.useEffect(() => {
    if (
      stampDutyOptions.loading === false &&
      stampDutyOptions.data.length === 0
    ) {
      props.getStampDutyOptions();
    }
  }, []);

  return (
    <StdCard title="Request information" style={{ marginTop: "1rem" }}>
      <RICont>
        <RowFields>
          <Field
            name="title"
            label="Title"
            type={type.text}
            component={FieldInput}
            editable={!isDetail}
            require
            maxLength={200}
            maxLengthMessage="Title must be less than or equal to 200 characters"
            tooltip={isDetail}
          />
          <Field
            name="requesterUser"
            label="Requester"
            require
            component={FieldInput}
            allowAdditions={false}
            loading={props.members.loading}
            options={props.members.map((m, i) => ({
              key: i,
              value: lower(m.username),
              text: `${m.firstnameEn} ${m.lastnameEn}`,
            }))}
            editable={!isDetail}
            type={type.select}
          />
        </RowFields>
        <RowFields>
          <Field
            name="procurementReviewer"
            label="Procurement Review"
            component={FieldInput}
            allowAdditions={false}
            loading={
              isDetail ? props.members.loading : props.purchaseUsers.loading
            }
            options={
              isDetail
                ? props.members.map((m, i) => ({
                    key: i,
                    value: lower(m.username),
                    text: `${m.firstnameEn} ${m.lastnameEn}`,
                  }))
                : props.purchaseUsers.data.map((m, i) => ({
                    key: i,
                    value: lower(m.username),
                    text: `${m.firstnameEn} ${m.lastnameEn}`,
                  }))
            }
            type={type.selectwithnull}
            editable={!isDetail}
            className="halfRow"
          />
          {isNewVersion ? null : (
            <Field
              require
              name="stampDutyType"
              label="Type Stamp Duty"
              type={type.select}
              options={stampDutyOptions.data}
              component={FieldInput}
              editable={!isDetail}
            />
          )}
        </RowFields>
        <RowFields>
          <Field
            name="companyName"
            label="Company"
            type={type.text}
            component={FieldInput}
            editable={false}
          />
          <Field
            name="projectName"
            label="Project Name"
            type={type.text}
            component={FieldInput}
            editable={false}
          />
        </RowFields>
        <RowFields>
          <Field
            name="submittedDate"
            label="Submitted Date"
            type={type.date}
            component={FieldInput}
            editable={false}
          />
          <Field
            name="documentDate"
            label="Document Date"
            type={type.date}
            component={FieldInput}
            editable={false}
          />
        </RowFields>
        <RowFields>
          <Field
            name="modifiedDate"
            label="Modified Date"
            type={type.date}
            component={FieldInput}
            editable={false}
            className="halfRow"
          />
        </RowFields>
      </RICont>
    </StdCard>
  );
};

const mapStateToProps = (state) => ({
  members: state.member.members,
  purchaseUsers: state.member.purchaseUsers,
  stampDutyOptions: state.options.stampDuty,
});

const mapDispatchToProps = {
  getStampDutyOptions,
};

export default connect(mapStateToProps, mapDispatchToProps)(RequestInformation);
